import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views'),
      children: [
        // users
        {
          path: 'users',
          name: 'users',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Users')
        },
        {
          path: 'user-details/:id',
          name: 'user.details',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Users/UserDetails')
        },
        // admins
        {
          path: 'admins/:id',
          name: 'admin.details',
          component: () =>
            import(/* webpackChunkName: "admins" */ '@/views/Admins/Details')
        },
        // inquiries
        {
          path: 'inquiries',
          name: 'inquiries',
          component: () =>
            import(/* webpackChunkName: "inquiries" */ '@/views/Inquiries')
        },
        {
          path: 'inquiries/:id',
          name: 'inquiries.details',
          components: {
            default: () =>
              import(/* webpackChunkName: "inquiries" */ '@/views/Inquiries'),
            dialog: () =>
              import(/* webpackChunkName: "inquiries" */ '@/views/Inquiries/Detail')
          }
        },
        // news
        {
          path: 'news',
          name: 'news',
          component: () => import(/* webpackChunkName: "news" */ '@/views/News')
        },
        {
          path: 'notifications',
          name: 'notifications',
          component: () =>
            import(/* webpackChunkName: "notifications" */ '@/views/Notifications')
        },
        {
          path: 'news/create',
          name: 'news.create',
          component: () =>
            import(/* webpackChunkName: "news" */ '@/views/News/Create')
        },
        {
          path: 'news/:id/edit',
          name: 'news.edit',
          component: () =>
            import(/* webpackChunkName: "news" */ '@/views/News/Edit')
        },
        // resources
        {
          path: 'resources',
          name: 'resources',
          component: () =>
            import(/* webpackChunkName: "news" */ '@/views/Resources')
        },
        {
          path: 'resources/create',
          name: 'resources.create',
          components: {
            default: () =>
              import(/* webpackChunkName: "resources" */ '@/views/Resources'),
            dialog: () =>
              import(/* webpackChunkName: "resources" */ '@/views/Resources/Create')
          }
        },
        {
          path: 'resources/:id/edit',
          name: 'resources.edit',
          component: () =>
            import(/* webpackChunkName: "news" */ '@/views/Resources/Edit')
        },
        // training
        {
          path: 'training/blogs',
          name: 'training.blogs',
          component: () =>
            import(/* webpackChunkName: "training" */ '@/views/Training/Blog')
        },
        {
          path: 'training/blogs/create',
          name: 'training.blogs.create',
          component: () =>
            import(/* webpackChunkName: "training" */ '@/views/Training/Blog/Create')
        },
        {
          path: 'training/blogs/:id/edit',
          name: 'training.blogs.edit',
          component: () =>
            import(/* webpackChunkName: "training" */ '@/views/Training/Blog/Edit')
        },
        {
          path: 'training/resources',
          name: 'training.resources',
          component: () =>
            import(/* webpackChunkName: "training" */ '@/views/Resources')
        },
        {
          path: 'training/resources/create',
          name: 'training.resources.create',
          components: {
            default: () =>
              import(/* webpackChunkName: "training" */ '@/views/Resources'),
            dialog: () =>
              import(/* webpackChunkName: "training" */ '@/views/Resources/Create')
          }
        },
        {
          path: 'training/resources/:id/edit',
          name: 'training.resources.edit',
          component: () =>
            import(/* webpackChunkName: "training" */ '@/views/Resources/Edit')
        },
        {
          path: 'calendar/master',
          name: 'calendar.master',
          component: () =>
            import(/* webpackChunkName: "calendar" */ '@/views/Calendar/Master')
        },
        {
          path: 'calendar/mustard',
          name: 'calendar.mustard',
          component: () =>
            import(/* webpackChunkName: "calendar" */ '@/views/Calendar/Mustard')
        },
        // Suggestions
        {
          path: 'suggestions',
          name: 'suggestions',
          component: () =>
            import(/* webpackChunkName: "suggestions" */ '@/views/Suggestions')
        },
        // Reports
        {
          path: 'report/posts',
          name: 'report.posts',
          component: () =>
            import(/* webpackChunkName: "reports" */ '@/views/Reports/Post')
        },
        {
          path: 'report/comments',
          name: 'report.comments',
          component: () =>
            import(/* webpackChunkName: "reports" */ '@/views/Reports/Comment')
        },
        // Groups
        {
          path: 'groups',
          name: 'groups',
          component: () =>
            import(/* webpackChunkName: "groups" */ '@/views/Groups')
        },
        {
          path: 'groups/:id/edit',
          name: 'groups.edit',
          component: () =>
            import(/* webpackChunkName: "groups" */ '@/views/Groups/Edit')
        }
      ]
    }
  ]
})
